import axios from 'axios'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import Vue from 'vue'
import App from './App.vue'
import adapter from 'webrtc-adapter'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueNativeSock from 'vue-native-websocket'
import websocketActions from './store/actions/websocket'
import { getLocalStorage } from './utils/storage'

// Test local storage.
getLocalStorage()

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

// Session authentication: Must send CSRFToken in POST data, or set
// X-CSRFTOKEN header.
// https://docs.djangoproject.com/en/3.0/ref/csrf/
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.xsrfCookieName = 'csrftoken'

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this
    // function to trigger
    return response
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this
    // function to trigger
    if (error &&
        error.response &&
        error.response.status === 403 &&
        // When a session is deleted in the backend the response details is:
        // "Authentication credentials were not provided."
        error.config &&
        !error.config.__isRetryRequest) {
      // If are denied access (e.g. session has expired), logout.
      // router.push({ name: 'logout' })
    }
    return Promise.reject(error)
  }
)

// Initialise WebSockets.
Vue.use(VueNativeSock, process.env.VUE_APP_WS_URL, {
  connectManually: true,
  format: 'json',
  store: store,
  mutations: websocketActions,
  reconnection: true,
  reconnectionDelay: 5 * 1000, // Five seconds.
  // Hack for VueNativeSock not allowing non-root stores.
  // https://github.com/nathantsoi/vue-native-websocket/issues/40
  passToStoreHandler: function (eventName, event) {
    if (!eventName.startsWith('SOCKET_')) { return }
    let method = 'commit'
    let target = 'websocket/' + eventName.toUpperCase()
    let msg = event
    if (this.format === 'json' && event.data) {
      msg = JSON.parse(event.data)
      if (msg.mutation) {
        target = [msg.namespace || '', msg.mutation].filter((e) => !!e).join('/')
      } else if (msg.action) {
        method = 'dispatch'
        target = [msg.namespace || '', msg.action].filter((e) => !!e).join('/')
      }
    }
    this.store[method](target, msg)
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
